// extracted by mini-css-extract-plugin
export default {"circle":"SkillCircle_circle__rytR8","img":"SkillCircle_img__DUq6o"};